import { FontFamilyMap } from 'types'

export const FONT_FAMILY_MAP: FontFamilyMap = {
  regular: 'Roboto-Regular',
  medium: 'Roboto-Medium',
  bold: 'Roboto-Bold',
  brand: 'ReemKufi-Regular',
}
